import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

/**
 * Listens for service-worker updates and shows a banner to the user.
 * The SW registration logic lives in index.js; this component subscribes
 * to a custom "sw-update-ready" event dispatched on `window`.
 */
export const UpdateBanner = () => {
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    const handler = (e) => setWaitingWorker(e.detail || null);
    window.addEventListener("sw-update-ready", handler);
    return () => window.removeEventListener("sw-update-ready", handler);
  }, []);

  if (!waitingWorker) return null;

  const refresh = () => {
    try {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
    } catch (_) {
      /* ignored */
    }
    // index.js listens for controllerchange and reloads once the new SW is in control.
    // Fallback: if the SW activation stalls, reload after 3s.
    setTimeout(() => window.location.reload(), 3000);
  };

  return (
    <div
      data-testid="update-banner"
      className="fixed top-3 left-1/2 -translate-x-1/2 z-50 max-w-md w-[calc(100%-1.5rem)] sm:w-auto"
    >
      <div
        className="flex items-center gap-3 rounded-full pl-4 pr-2 py-2"
        style={{
          background: "var(--brand-primary)",
          color: "var(--ink-on-brand)",
          boxShadow: "var(--shadow-hover)",
          border: "1px solid rgba(255,255,255,0.20)",
        }}
      >
        <RefreshCw className="h-4 w-4 shrink-0" />
        <span className="text-sm font-medium flex-1">New version available</span>
        <button
          data-testid="update-banner-refresh"
          onClick={refresh}
          className="px-3 py-1.5 rounded-full text-xs font-semibold"
          style={{
            background: "var(--ink-on-brand)",
            color: "var(--brand-primary)",
            transition: "background-color var(--duration-base) var(--ease-standard)",
          }}
        >
          Tap to refresh
        </button>
      </div>
    </div>
  );
};
